import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {Module} from '../types';
import {State} from './types';

const initialState: State = {
  moduleData: undefined,
  version: undefined,
};

function initSlice() {
  const slice = createSlice({
    name: 'localization',
    initialState,
    reducers: reducer,
  });
  return slice;
}

const reducer = {
  setModuleData: function (state: State, action: PayloadAction<Module>) {
    state.moduleData = action.payload;
  },
  setVersion: function (state: State, action: PayloadAction<string>) {
    state.version = action.payload;
  },
};

export default initSlice();
